import GridIcon from "@/assets/images/icons/grid-icon.svg";
import ListIcon from "@/assets/images/icons/list-icon.svg";
import { DashboardOutlinedIconButton } from "@/components/ui/DashboardOutlinedIconButton";
import {
  DASHBOARD_TOOLBAR_ICON_PX,
  dashboardToolbarIconColor,
} from "@/lib/dashboardToolbarUi";
import React from "react";
import { XStack, type XStackProps } from "tamagui";

type DashboardViewModeToggleProps = {
  viewMode: "grid" | "list";
  onViewModeChange: (mode: "grid" | "list") => void;
} & Omit<XStackProps, "children">;

export function DashboardViewModeToggle({
  viewMode,
  onViewModeChange,
  gap = "$1.5",
  ...stackProps
}: DashboardViewModeToggleProps) {
  return (
    <XStack ai="center" gap={gap} {...stackProps}>
      <DashboardOutlinedIconButton
        onPress={() => onViewModeChange("grid")}
        active={viewMode === "grid"}
        accessibilityLabel="Grid view"
      >
        <GridIcon
          width={DASHBOARD_TOOLBAR_ICON_PX}
          height={DASHBOARD_TOOLBAR_ICON_PX}
          color={dashboardToolbarIconColor(viewMode === "grid")}
        />
      </DashboardOutlinedIconButton>
      <DashboardOutlinedIconButton
        onPress={() => onViewModeChange("list")}
        active={viewMode === "list"}
        accessibilityLabel="List view"
      >
        <ListIcon
          width={DASHBOARD_TOOLBAR_ICON_PX}
          height={DASHBOARD_TOOLBAR_ICON_PX}
          color={dashboardToolbarIconColor(viewMode === "list")}
        />
      </DashboardOutlinedIconButton>
    </XStack>
  );
}
